import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(
    private translateService: TranslateService,
    private messageService: MessageService
  ) {}

  private t(key: string, fallback: string): string {
    const value = this.translateService.instant(key);
    return !value || value === key ? fallback : value;
  }

  openSnackBar(message: string, type: string = null) {
    let snackbarClass;
    let snackbarIcon;
    let snackbarTitle;

    switch (type) {
      case 'error':
        snackbarClass = 'red-snackbar';
        snackbarIcon = 'cancel';
        snackbarTitle = this.t('errors.snackbar-error', 'خطأ');
        break;
      case 'warning':
        snackbarClass = 'orange-snackbar';
        snackbarIcon = 'warning';
        snackbarTitle = this.t('errors.snackbar-warning', 'تنبيه');
        break;
      case 'success':
        snackbarClass = 'green-snackbar';
        snackbarIcon = 'check_circle_outline';
        snackbarTitle = this.t('errors.snackbar-success', 'نجاح');
        break;
      default:
        snackbarClass = 'light-snackbar';
        snackbarIcon = 'info';
        snackbarTitle = this.t('errors.snackbar-info', 'معلومة');
    }

    this.messageService.add({
      summary: snackbarTitle,
      detail: message,
      life: 3000,
      styleClass: snackbarClass,
      icon: snackbarIcon,
      key: 'tc',
    });
  }

  /** Silent for guest 401 / expected auth failures */
  isAuthNoise(e: any): boolean {
    const status = e?.status ?? e?.error?.status;
    return status === 401 || status === 403;
  }

  showError(e, snackbar = null) {
    if (this.isAuthNoise(e)) {
      return e?.error?.error || null;
    }

    const apiMsg =
      (typeof e?.error === 'object' && (e.error?.error || e.error?.message || e.error?.msg)) ||
      (typeof e?.error === 'string' ? null : null);

    if (apiMsg && snackbar) {
      snackbar.openSnackBar(apiMsg, 'error');
      return apiMsg;
    }
    if (apiMsg && !snackbar) {
      return apiMsg;
    }

    console.error(e);
    const errorMsg = this.t(
      'errors.generic-error',
      'حدث خطأ ما، يرجى المحاولة فى وقت لاحق!'
    );
    this.openSnackBar(errorMsg, 'error');
    return errorMsg;
  }
}
